import React, { useState, useEffect, useContext } from "react";
import Heading from "../../Components/Heading/Heading";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { APICall } from "../../Helpers/API/APICalls";
import {
  ExporttoExcelTTraceabilityWorkPacket,
  GetEngagementForWorkpacket,
  GetWorkPacketUploadTemplate,
  UploadWorkPacketUploadExcel,
  getAssignedsTo,
  getRequirement,
  getWorkPacketUploadTracibilityGrid,
  getWorkPacketUploadTracibilityGridById,
  updateWorkPacketUploadGridData,
} from "../../Helpers/API/APIEndPoints";
import axios from "axios";
import fileDownload from "js-file-download";
import { APICalls } from "../../Helpers/API/APICalls2";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import moment from "moment";
import notify from "../../Helpers/ToastNotification";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import uuid from "react-uuid";
// import Modal from "@mui/material/Modal";
import { Modal } from "react-bootstrap";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import InputForm from "../../Components/InputForm/InputForm";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { Tooltip } from "antd";

const TraceabilityWorkPacketUpload = () => {
  const { EmployeeId, RoleId } = getContext();
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [selectedEngagement, setSelectedEngagement] = useState<any>({});
  const [RequirementOptions, setRequirementOptions] = useState<any>([]);
  const [selectedRequirement, setSelectedRequirement] = useState<any>({});
  const [AssignedToOptions, setAssignedToOptions] = useState<any>([]);
  const [selectedAssignedTo, setSelectedAssignedTo] = useState<any>({});
  const [title, setTitle] = useState<any>("");
  const [description, setDescription] = useState("");
  const [PlannedHours, setPlannedHours] = useState<any>(0);
  const [startByDate, setStartByDate] = useState<Date | null>(null);
  const [completedByDate, setCompletedByDate] = useState<Date | null>(null);
  const [tomorrowDate, settomorrowDate] = useState<Date | null>(null);
  const [FormErrors, setFormErrors] = useState<any>({});
  const [excelFileContent, setExcelFileContent] = useState<any>("");
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [excelFileName, setExcelFileName] = useState<any>("No File Uploaded");
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [editId, setEditId] = useState<any>("");
  const [ModalFormErrors, setModalFormErrors] = useState<any>({});
  const [
    workPacketUploadTraceabilityData,
    setWorkPacketUploadTraceabilityData,
  ] = useState<any>([]);
  const [
    workPacketUploadTraceabilityDataById,
    setWorkPacketUploadTraceabilityDataById,
  ] = useState<any>({});
  let formErrorObj = {};
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [currentStatus,setCurrentStatus] = useState("");
  // added a new usestate for the status, Raj potdar, Date: 29-1-2024
  const [isactivestring, setIsActiveString] = useState("active");
  let modalFormErrorObj = {};
  const GetEngagementForProductandProject = async () => {
    if (RoleId.includes(3) || RoleId.includes(6) || RoleId.includes(8)) {
      let data = await APICall(GetEngagementForWorkpacket, "POST", {});

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    } else if (RoleId.includes(2)) {
      const obj = {
        Id: EmployeeId,
      };
      let EngagementByLeadData = await APICall(
        GetEngagementForWorkpacket,
        "POST",
        obj
      );

      if (EngagementByLeadData.data.length > 0) {
        let tempArray = [];
        await EngagementByLeadData.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    }
  };

  useEffect(() => {
    localStorage.clear(); //deepak gupta
    (async () => {
      await GetEngagementForProductandProject();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await WorkPacketUploadGetGrid();
      await getRequirements();
    })();
    // added a new parameter isactivestring, Raj potdar, Date: 29-11-2024
  }, [
    selectedEngagement,
    start,
    sortColumn,
    sortDirection,
    searchText,
    isactivestring,
  ]);

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
      setSelectedEngagement(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
        setPage(0);
        setStart(0);
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Enagagement type can not be empty",
        }));
      }
    }

    if (apiFieldName === "requirement") {
      setSelectedRequirement(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["Requirement_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["Requirement_isEmpty"]: "requirement can not be empty",
        }));
      }
    }

    if (apiFieldName === "AssignedTo") {
      setSelectedAssignedTo(event);
    }

    if (apiFieldName === "title") {
      setTitle(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["Title_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["Title_isEmpty"]: "Title can't be empty",
        }));
      }
    }
    if (apiFieldName === "description") {
      setDescription(event.target.value);
    }

    if (apiFieldName === "plannedHours") {
      setPlannedHours(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["PlannedHours_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["PlannedHours_isEmpty"]: "PlannedHours can't be empty",
        }));
      }
    }

    if (apiFieldName === "startByDate") {
      // setStartByDate(event.target.value);
      // setModalFormErrors((preState) => ({
      //   ...preState,
      //   ["startByDate_isEmpty"]: "",
      // }));
      // if (
      //   event.target.value == undefined ||
      //   event.target.value == null ||
      //   event.target.value == ""
      // ) {
      //   setModalFormErrors((preState) => ({
      //     ...preState,
      //     ["startByDate_isEmpty"]: "Start by date can't be empty",
      //   }));
      // }
      setStartByDate(event);
      if (event) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["startByDate_isEmpty"]: undefined,
        }));
      } else {
        setModalFormErrors((preState) => ({
          ...preState,
          ["startByDate_isEmpty"]: "Start by date can not be empty",
        }));
      }
    }

    if (apiFieldName === "completedByDate") {
      setCompletedByDate(event);
      if (event) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["completedByDate_isEmpty"]: undefined,
        }));
      } else {
        setModalFormErrors((preState) => ({
          ...preState,
          ["completedByDate_isEmpty"]: "Completed by date can not be empty",
        }));
      }
    }
  };

  const WorkPacketUploadGetGrid = async () => {
    await showLoader();
    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      EngagementId: selectedEngagement.value,
      // added a new parameter activeStatusId, Raj potdar, Date: 29-11-2024
      activeStatusId: isactivestring,
    };

    const { data } = await APICall(
      getWorkPacketUploadTracibilityGrid,
      "POST",
      requestParams
    );

    if (data.length > 0) {
      await data.forEach((ele: any) => {
        ele.startbyDate = moment(ele.startbyDate).format("DD-MM-yyyy");
        ele.completedbyDate = moment(ele.completedbyDate).format("DD-MM-yyyy");
      });
      await setWorkPacketUploadTraceabilityData(data);
      setCount(data[0].totalCount);
    } else {
      setPage(0);
      setStart(0);
      setCount(0);
      setWorkPacketUploadTraceabilityData([]);
    }
    await hideLoader();
  };

  const reset = () => {
    showLoader();
    setExcelFileName("No File Uploaded");
    setExcelFileContent("");
    setSelectedEngagement({});
    hideLoader();
  };

  const handleFiles = (e: any) => {
    debugger;
    setExcelFileName(e.target.files[0].name);
    setFormErrors((preState) => ({
      ...preState,
      ["bulkUploadRequestExcel_isEmpty"]: undefined,
    }));
    var f = e.target.files[0];
    setExcelFileContent(f);
    e.target.value = "";
  };

  const onSubmitValidation = async () => {
    await setFormErrors({});
    formErrorObj = {};
    if (!selectedEngagement || Object.keys(selectedEngagement).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Engagement cannot be empty",
      }));
      formErrorObj["engagement_isEmpty"] = "Engagement cannot be empty";
    }

    if (
      !excelFileName ||
      excelFileName === "" ||
      excelFileName === "No File Uploaded"
    ) {
      formErrorObj["bulkUploadRequestExcel_isEmpty"] = "please upload file.";
      setFormErrors(formErrorObj);
    }
  };

  //
  const onClickFunction = async (action: any) => {
    debugger;
    if (action === "submit") {
      setDisabled(true);
      showLoader();
      await onSubmitValidation();

      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty == true) {
        setDisabled(false);
        var formdata = new FormData();

        formdata.append("file", excelFileContent);
        formdata.append("EngagementId", selectedEngagement.value);
        formdata.append(
          "CreatedDate",
          moment(new Date()).format(moment.HTML5_FMT.DATE)
        );
        formdata.append("CreatedBy", EmployeeId);
        formdata.append("TaskUid", uuid());

        const { data } = await APICalls(
          UploadWorkPacketUploadExcel,
          "POST",
          formdata
        );
        if (data != undefined || data != null) {
          if (data.responseStatus === 2) {
            var splitted = data.response.split("\n");
            const ErrorList = () => {
              return (
                <ul>
                  {splitted.map((error: string, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              );
            };
            notify(1, <ErrorList />);
            setExcelFileName("No File Uploaded");
            setExcelFileContent("");
            WorkPacketUploadGetGrid();
          } else {
            notify(0, "WorkPacket Excel Uploaded Successfully");
            setExcelFileName("No File Uploaded");
            setExcelFileContent("");
            WorkPacketUploadGetGrid();
          }
        }
      } else {
        setDisabled(false);
      }
      hideLoader();
    } else if (action === "Download") {
      showLoader();

      if (!selectedEngagement || Object.keys(selectedEngagement).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Engagement can not be empty",
        }));
        formErrorObj["engagement_isEmpty"] = "Engagement can not be empty";
      } else {
        axios
          .request({
            responseType: "blob",
            method: "POST",

            //data: Response,
            url: GetWorkPacketUploadTemplate,
            //data:JSON,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              "Access-Control-Allow-Headers": "*",
            },
            data: {
              EngagementId: selectedEngagement.value,
            },
          })
          .then((response) => {
            if (
              response.data.type == "application/json" &&
              response.data.size == 55
            ) {
              notify(1, "No Active requirements found for this engagement");
            } else if (
              response.data.type == "application/json" &&
              response.data.size == 106
            ) {
              notify(
                1,
                "There are no employees assigned or allocated for the selected engagement"
              );
            } else {
              fileDownload(
                response.data,
                selectedEngagement.label + "WorkPacketUpload.xlsx"
              );
            }
          })
          .catch((error) => {
            console.error(error.response.data);
          });
      }
      hideLoader();
    } else if (action == "reset") {
      reset();
    }
  };

  const style = {
    position: "fixed",
    top: "10%",
    left: "10%",
    backgroundColor: "background.paper",
    zIndex: "1000",
    overflowY: "auto",
    width: "80%",
    height: "80%",
    backdrop: "static",
    boxShadow: 24,
    p: 4,
    borderRadius: 3,
  };

  const options = {
    selectableRows: "none",
    start: start,
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setPage(page);
      setStart(page * pageSize);
    },
    // added a new function for a new filter option, Raj Potdar, Date : 29-11-2024
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactivestring}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };
  const handleChange = (event: SelectChangeEvent) => {
    setIsActiveString(event.target.value);
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: "requirement",
      label: "Requirement",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "plannedHours",
      label: "Planned Hours",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        // setCellProps: () => ({
        //   align: "center",
        // }),
        // setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "startbyDate",
      label: "Start Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        // setCellProps: () => ({
        //   align: "right",
        // }),
        // setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "completedbyDate",
      label: "Completed Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        // setCellProps: () => ({
        //   align: "right",
        // }),
        // setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "assignedTo",
      label: "Assigned To",
      options: {
        filter: false,
        sort: false,
        sortDirection: true,
      },
    },
    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let activeStatus = tableMeta.tableData[tableMeta.rowIndex].isActive;
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let taskStatus = tableMeta.tableData[tableMeta.rowIndex].taskStatus;
          let createdById = tableMeta.tableData[tableMeta.rowIndex].createdBy;
          let taskstartDate =
            tableMeta.tableData[tableMeta.rowIndex].startbyDate;
            console.log('taskstartDate - ',taskstartDate)
          let parts = taskstartDate.split("-");
            console.log('after split parts',parts)
          var dateString = parts[2] + "-" + parts[1] + "-" + parts[0];
          console.log('dateString',dateString)
          var parsedDate = new Date(dateString);
          console.log('parseDate',parsedDate)

          const s = tableMeta.tableData[tableMeta.rowIndex];

          if (
            taskStatus === "Not Started" &&
            createdById.toString() === EmployeeId &&
            activeStatus === true 
            //&&
            //parsedDate > new Date()
          ) {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a onClick={() => handleOpen(id,taskStatus)} className="action_icon">
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            );
          } else if (
            taskStatus === "In Progress" &&
            createdById.toString() === EmployeeId &&
            activeStatus === true
            // &&
            //parsedDate > new Date()
          ) {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a onClick={() => handleOpen(id,taskStatus)} className="action_icon">
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            );
          }
        },
      },
    },
  ];

  const getRequirements = async () => {
    let requestParams = {
      EngagementId: selectedEngagement.value,
    };
    const { data } = await APICall(getRequirement, "POST", requestParams);
    if (data.length > 0) {
      let tempArray = [];
      await data.map((d: any) => {
        let tempObj = {
          label: d.title,
          value: d.id,
        };
        tempArray.push(tempObj);
      });
      setRequirementOptions(tempArray);
    }
  };

  const getAssignedTo = async (engagementId, startbyDate, completedbyDate) => {
    let requestParams = {
      EngagementId: engagementId,
      StartbyDate: moment(startbyDate).startOf("day").format("YYYY-MM-DD"),
      CompletedbyDate: moment(completedbyDate)
        .startOf("day")
        .format("YYYY-MM-DD"),
    };

    const { data } = await APICall(
      getAssignedsTo,
      "POST",
      requestParams
      //{}
    );
    if (data.length > 0) {
      let tempArray = [];
      await data.map((d: any) => {
        let tempObj = {
          label: d.title,
          value: d.id,
        };
        tempArray.push(tempObj);
      });
      setAssignedToOptions(tempArray);
    }
  };

  const getTaskDataById = async (id: number , taskStatus:any) => {
    //await getRequirements();

    let requestParams = {
      Id: id,
    };

    const { data } = await APICall(
      getWorkPacketUploadTracibilityGridById,
      "POST",
      requestParams
    );
    console.log('get task data by id --- data',data)
    if (data) {
      const formattedData = {
        ...data,
        startbyDate: moment(data.startbyDate).format("DD-MM-yyyy"),
        completedbyDate: moment(data.completedbyDate).format("DD-MM-yyyy"),
      };
      setSelectedRequirement({
        value: data.requirementId,
        label: data.requirement,
      });
      setSelectedAssignedTo({
        value: data.assignedToId,
        label: data.assignedTo,
      });
      setTitle(data.title);
      setDescription(data.description ? data.description : "");
      setPlannedHours(Number(data.plannedHours).toFixed(2));
      setStartByDate(new Date(data.startbyDate));
      setCompletedByDate(new Date(data.completedbyDate));
      setIsActive(data.isActive);
      setEditId(id);
      setWorkPacketUploadTraceabilityDataById(formattedData);
      setCurrentStatus(taskStatus);
      const todaysDate = new Date();
      const tomorrow = new Date(todaysDate);
      tomorrow.setDate(todaysDate.getDate() + 1);
      settomorrowDate(tomorrow);
      await getAssignedTo(
        data.engagementId,
        new Date(data.startbyDate),
        new Date(data.completedbyDate)
      );
    }
  };

  const handleOpen = async (id:any,taskStatus:any) => {
    await showLoader();

    await getTaskDataById(id,taskStatus);
    setOpen(true);
    await hideLoader();
  };

  const handleClose = () => {
    setModalFormErrors({});
    setOpen(false);
  };

  const UpdateDataValidation = async () => {
    modalFormErrorObj = {};
    await setModalFormErrors({});
    if (title === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["Title_isEmpty"]: "Title can't be empty",
      }));
      modalFormErrorObj["Title_isEmpty"] = "Title can't be empty";
    }

    if (!selectedRequirement || Object.keys(selectedRequirement).length === 0) {
      setModalFormErrors((preState) => ({
        ...preState,
        ["Requirement_isEmpty"]: "Requirement cannot be empty",
      }));
      modalFormErrorObj["Requirement_isEmpty"] = "Requirement cannot be empty";
    }

    if (PlannedHours == "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["PlannedHours_isEmpty"]: "PlannedHours can't be empty",
      }));
      modalFormErrorObj["PlannedHours_isEmpty"] = "PlannedHours can't be empty";
    }

    if (!startByDate) {
      setModalFormErrors((preState) => ({
        ...preState,
        ["startByDate_isEmpty"]: "start Date can't be empty",
      }));
      modalFormErrorObj["startByDate_isEmpty"] = "start Date can't be empty";
    } else if (startByDate <= new Date()) {
      setModalFormErrors((prevState) => ({
        ...prevState,
        ["startByDate_isInvalid"]:
          "startByDate cannot be less than or equal to today's date",
      }));
      modalFormErrorObj["startByDate_isInvalid"] =
        "startByDate cannot be less than or equal to today's date";
    }

    if (!completedByDate) {
      setModalFormErrors((preState) => ({
        ...preState,
        ["completedByDate_isEmpty"]: "completed Date can't be empty",
      }));
      modalFormErrorObj["completedByDate_isEmpty"] =
        "completed Date can't be empty";
    } else if (completedByDate < new Date()) {
      setModalFormErrors((prevState) => ({
        ...prevState,
        ["completedByDate_isInvalid"]:
          "completedByDate cannot be less than today's date",
      }));
      modalFormErrorObj["completedByDate_isInvalid"] =
        "completedByDate cannot be less than today's date";
    } else if (completedByDate < startByDate) {
      setModalFormErrors((prevState) => ({
        ...prevState,
        ["completedByDate_isInvalid"]:
          "completed Date cannot be less than start Date",
      }));
      modalFormErrorObj["completedByDate_isInvalid"] =
        "completed Date cannot be less than start Date";
    }
  };

  const UpdateWorkPacketUpload = async () => {
    showLoader();

    await UpdateDataValidation();
    const isEmpty = await Object.values(modalFormErrorObj).every(
      (x) => x === null || x === "" || x == undefined
    );

    if (isEmpty == true) {
      let reqObject = {
        Id: editId,
        RequirementId: selectedRequirement.value,
        Title: title,
        Description: description ? description : null,
        PlannedHours: Number(PlannedHours),
        StartbyDate: moment(startByDate).startOf("day").format("YYYY-MM-DD"),
        CompletedbyDate: moment(completedByDate)
          .startOf("day")
          .format("YYYY-MM-DD"),
        AssignedToId: selectedAssignedTo ? selectedAssignedTo.value : null,
        IsActive: isActive,
        ModifiedBy: Number(EmployeeId),
        ModifiedDate: moment().startOf("day").format("YYYY-MM-DD"),
        EngagementId: selectedEngagement.value,
      };

      const { data } = await APICall(
        updateWorkPacketUploadGridData,
        "POST",
        reqObject
      );

      if (data.responseStatus == 1) {
        notify(0, data.response);
        (async () => {
          await WorkPacketUploadGetGrid();
        })();
      } else if (data.responseStatus == 2) {
        notify(1, "Please allocate a capacity");
      } else {
        notify(1, "Update Failed");
      }
      setOpen(false);
    }
    hideLoader();
  };

  // Added by Omkar
  const ExportToExcel = () => {
    debugger;
    if (!selectedEngagement || !selectedEngagement.value) {
      setFormErrors((prev) => ({
        ...prev,
        engagement_isEmpty: "Engagement type cannot be empty.",
      }));
      return;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        engagement_isEmpty: "",
      }));
    }
    let obj = {
      start: start,
      pageSize: count,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      EngagementId: selectedEngagement.value,
      activeStatusId: isactivestring,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        url: ExporttoExcelTTraceabilityWorkPacket,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "TraceabilityWorkPacket.xlsx");
      })
      .catch((error) => {});
  };

  return (
    <>
      <Heading title={"Work Packet"} />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement <sup>*</sup>
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select"
                isDisabled={false}
                value={selectedEngagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{FormErrors["engagement_isEmpty"]}</p>
            </div>
          </div>
          {Object.keys(selectedEngagement).length > 0 && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Upload Excel <sup>*</sup>
                </label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      type="file"
                      accept=".xls,.xlsx"
                      className="custom-file-input"
                      id="file"
                      aria-describedby="inputGroupFileAddon01"
                      style={{ borderRadius: "2px" }}
                      onChange={(e) => {
                        handleFiles(e);
                      }}
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="inputGroupFile01"
                    >
                      {excelFileName}
                    </label>
                  </div>
                </div>
                <p style={{ color: "red" }}>
                  {FormErrors["bulkUploadRequestExcel_isEmpty"]}
                </p>
              </div>
            </div>
          )}
          {Object.keys(selectedEngagement).length > 0 && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>&nbsp;</label>
                <div className="d-flex gap-2 justify-content-end">
                  
                  <button
                    className="btn btn-export"
                    onClick={() => onClickFunction("Download")}
                  >
                    Download Template
                  </button>
                  <button
                    className="btn btn-submit"
                    onClick={() => onClickFunction("submit")}
                    disabled={disabled}
                  >
                    Upload
                  </button>
                  <button
                    className="btn btn-reset"
                    onClick={() => onClickFunction("reset")}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="col-lg-12">
            {selectedEngagement && selectedEngagement.value ?
              (<div className="d-flex gap-2 justify-content-end">
                <button
                    className="btn btn-export"
                    onClick={() => ExportToExcel()}
                  >
                    Export Excel
                  </button>
                </div>
                )
                :
              <></>
            }

          </div>

          <div className="col-lg-12 mt-3">
            {workPacketUploadTraceabilityData &&
              workPacketUploadTraceabilityData.length >= 0 && (
                <DynamicGrid
                  options={options}
                  data={workPacketUploadTraceabilityData}
                  columns={gridColumns}
                />
              )}
          </div>
        </div>
      </div>
      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        scrollable={true}
      >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Requirement <sup>*</sup>
                </label>
                <SelectForm
                  options={RequirementOptions}
                  placeholder="Select"
                  isDisabled={currentStatus == "In Progress"? true:false}
                  value={selectedRequirement}
                  onChange={(event) => selectOnChange(event, "requirement")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["requirement_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Title <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={currentStatus == "In Progress"? true:false}
                  placeholder={""}
                  textArea={false}
                  value={title}
                  onChange={(event) => selectOnChange(event, "title")}
                />
              </div>
              <p style={{ color: "red" }}>{ModalFormErrors["Title_isEmpty"]}</p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Planned Hours <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={false}
                  placeholder={""}
                  textArea={false}
                  value={PlannedHours}
                  onChange={(event) => selectOnChange(event, "plannedHours")}
                />
              </div>
              <p style={{ color: "red" }}>
                {ModalFormErrors["PlannedHours_isEmpty"]}
              </p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Start Date <sup>*</sup>
                </label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disabled = {currentStatus == "In Progress"? true:false}
                    label="Start By Date"
                    value={startByDate}
                    onChange={(event) => selectOnChange(event, "startByDate")}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                    minDate={currentStatus == "In Progress"? null:tomorrowDate}
                  />
                </LocalizationProvider>
              </div>
              <p style={{ color: "red" }}>
                {ModalFormErrors["startByDate_isEmpty"]}
                {ModalFormErrors["startByDate_isInvalid"]}
              </p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Completed Date<sup>*</sup>
                </label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Completed By Date"
                    value={completedByDate}
                    onChange={(event) =>
                      selectOnChange(event, "completedByDate")
                    }
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                    minDate={startByDate}
                  />
                </LocalizationProvider>
              </div>
              <p style={{ color: "red" }}>
                {ModalFormErrors["completedByDate_isEmpty"]}
                {ModalFormErrors["completedByDate_isInvalid"]}
              </p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>Assigned To</label>
                <SelectForm
                  options={AssignedToOptions}
                  placeholder="Select"
                  isDisabled={false}
                  value={selectedAssignedTo}
                  onChange={(event) => selectOnChange(event, "AssignedTo")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                  isClearable={true}
                />
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Description</label>
                  <InputForm
                    isDisabled={currentStatus == "In Progress"? true:false}
                    placeholder={""}
                    textArea={false}
                    value={description}
                    onChange={(event) => selectOnChange(event, "description")}
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="isActive" className="mr-2">
                    Is Active
                  </label>
                  <input
                    id="isActive"
                    type="checkbox"
                    onChange={(e) => setIsActive(e.target.checked)}
                    name="isActive"
                    checked={isActive}
                    disabled = {currentStatus == "In Progress"? true:false}
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    onClick={(e) => handleClose()}
                    className="btn btn-reset"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={UpdateWorkPacketUpload}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TraceabilityWorkPacketUpload;
